import { ScopeVersion, StatusType } from '@app/core/model/scope-version'

import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { AuthService } from '@app/core/service/auth.service'
import { FolderOverviewSelectors } from '../selectors'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { Injectable } from '@angular/core'
import { SowRetainedHoursStats } from '@app/features/scope-overview/model/sow-retained-hours-stats.model'
import { Store } from '@ngrx/store'
import { isNil } from 'lodash'

@Injectable({ providedIn: 'root' })
export class FolderOverviewService {
  private _folderId: number
  get folderId(): number {
    return this._folderId
  }
  set folderId(id: number) {
    this._folderId = id
  }

  private _isTrafficable: boolean
  get isTrafficable(): boolean {
    return this._isTrafficable
  }
  set isTrafficable(value: boolean) {
    this._isTrafficable = value
  }

  trafficableScopes: ScopeVersion[]
  trafficSystem: any
  timesheetConfigType: any

  constructor(
    private store$: Store,
    private authService: AuthService
  ) {
    this.store$.select(FolderOverviewSelectors.selectFolder).subscribe((folder) => {
      if (folder) this.refreshTrafficValues(folder)
    })
  }

  getUsedRetainedHoursForScope(scope: ScopeVersion, retainedHoursStats: SowRetainedHoursStats) {
    const scopeRetainedHoursStats = retainedHoursStats?.scopeStats?.find((scopeStats) => scopeStats.scopeId == scope.id)
    return scopeRetainedHoursStats?.totalHours
  }

  private refreshTrafficValues(folder: FolderVersion) {
    this.trafficableScopes = this.getTrafficableScopes(folder.scopeVersions)
    this.isTrafficable = !isNil(folder) && !!this.trafficableScopes.length

    const settings = this.authService.loggedInUser.company?.trafficSystemSettings
    this.trafficSystem = !isNil(settings) ? settings.trafficSystem : null
    this.timesheetConfigType =
      this.trafficSystem && this.trafficSystem.externalTrafficSystemConfig.scopeTimeSheet
        ? this.trafficSystem.externalTrafficSystemConfig.scopeTimeSheet.type
        : null
  }

  private getTrafficableScopes = (scopes: ScopeVersion[]) => scopes.filter((scope) => this.isEligibleForTraffic(scope))

  private isEligibleForTraffic(scope: ScopeVersion) {
    const currentUser = this.authService.loggedInUser
    const isTrafficable = scope.traffickable
    const isUserEligible = !!scope.identity.team.traffickers.filter((item) => item.user.id == currentUser.id).length

    const permissions = {
      draft: currentUser.company.hasApplicationSetting(ApplicationSetting.TRAFFICKABLE_ON_STATUS__DRAFT),
      review: currentUser.company.hasApplicationSetting(ApplicationSetting.TRAFFICKABLE_ON_STATUS__REVIEW),
      agree: currentUser.company.hasApplicationSetting(ApplicationSetting.TRAFFICKABLE_ON_STATUS__AGREE),
    }

    return isTrafficable && isUserEligible
      ? (scope.status === StatusType.DRAFT && permissions.draft) ||
          (scope.status === StatusType.REVIEWED && permissions.review) ||
          (scope.status === StatusType.CLIENT_APPROVED && permissions.agree)
      : false
  }
}
